import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterService } from '../../filter-service/filter.service';
import { IFacetGroup } from '../../models/filter.models';
import { FilterPageService } from '../../pages/filter-page/filter-page.service';
import { FILTER_FACET } from '../../filter-service/filter.models';

@Component({
    selector: 'app-highlighted-filter',
    template: `
        <section class="highlighted-filter">
            <app-highlighted-facet *ngIf="facet" [facet]="facet.options" [facetKey]="facet.key"></app-highlighted-facet>
        </section>
    `,
})
export class HighlightedFilterComponent implements OnInit, OnDestroy {
    facet?: IFacetGroup;

    private readonly unsubscribe = new Subject<void>();
    constructor(public readonly filterPageService: FilterPageService, public readonly filterService: FilterService) {}

    ngOnInit(): void {
        const connectStream$ = combineLatest([this.filterPageService.facets$, this.filterService.activeFacets]);

        connectStream$.pipe(takeUntil(this.unsubscribe)).subscribe(([allFacets$, activeFacets$]) => {
            const activeFacetsArr = Object.values(activeFacets$).reduce((acc, key) => [...acc, ...key], []);

            const models = allFacets$.sorted?.find((f) => f.key === FILTER_FACET.MODEL);
            const brands = allFacets$.sorted?.find((f) => f.key === FILTER_FACET.MAKE);
            const facet = models || brands;
            if (facet?.options?.items) {
                facet.options.items = facet?.options?.items?.filter((i) => !activeFacetsArr.find((af) => af === i.key));
            }

            this.facet = facet;
        });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
